export default "__VITE_ASSET__C_oL7O_0__"